import React from 'react'
import Typography from '@mui/material/Typography'
import grey from '@mui/material/colors/grey'
import parse from 'html-react-parser';

export default function TableTitle(props) { 
  const { titleText } = props;

  return (
    <Typography 
      align="center" 
      variant="subtitle2"
      sx={{ p:1, border:"1pt solid " + grey[500], borderBottom: "0", backgroundColor: "#F5F5F5"}}
    >
      {parse(titleText)}
    </Typography>
  )
}